import { isPlatformWeb, isPlatformAndroid, isPlatformIos, isPlatformTvos } from 'renative';
import { IOneTrustMobile, IOneTrustWeb } from './types';
import { OneTrustWeb, OneTrustMobile } from './services';

const getInstance = (): IOneTrustMobile | IOneTrustWeb | undefined => {
    if (isPlatformWeb) {
        return new OneTrustWeb();
    }
    if (isPlatformAndroid || isPlatformIos || isPlatformTvos) {
        return new OneTrustMobile();
    }

    return undefined;
};

export const OneTrust = getInstance();
